export const GET_SETTINGS = 'CMS/get_settings';
export const GET_PAPER_SETTINGS = 'CMS/get_paper_settings';
export const GET_SINGLE_SETTING = 'CMS/get_single_setting';
export const UPDATE_SETTING = 'CMS/update_setting';
export const CREATE_SETTING = 'CMS/create_setting';
export const REMOVE_SETTING = 'CMS/remove_setting';
export const REMOVE_TEMPLATE = 'CMS/remove_template';

export const GET_ROLE_LIST = 'ROLE/get_role_list';
export const GET_CEDULA_INTEREST = 'CMS/get_cedula_interest';
export const UPDATE_CEDULA_INTEREST = 'CMS/update_cedula_interest';

export const FORM_DATA = {
  name: '',
};

export const PERMIT_APPLICATIONS = [
  'activity_type',
  'amount',
  'amount_in_words',
  'area',
  'floor_area',
  'area_formatted',
  'barangay_code',
  'barangay_name',
  'base_line',
  'bin',
  'business_address',
  'business_line',
  'business_line_with_code',
  'business_lines',
  'business_lines_with_code',
  'business_name',
  'business_nature_name',
  'business_plate_number',
  'business_status',
  'capital_amount_formatted',
  'cda_no',
  'cellphone_no',
  'designation',
  'details',
  // 'display_address',
  'dti_no',
  'email_address',
  'e_permit_no',
  'fees',
  'hold_remarks',
  'incharge_first_name',
  'incharge_last_name',
  'incharge_middle_name',
  'incharge_suffix_name',
  'is_hold',
  'is_retired',
  // 'is_same_as_business_address',
  'printed_date',
  'printed_date_day',
  'printed_date_month',
  'printed_date_year',
  'printed_days_of_week',
  'kind_of_ownership',
  'lessor_name',
  'location_owned',
  'mode_of_payment',
  'monthly_rental',
  'monthly_rental_formatted',
  'municipality_code',
  'municipality_name',
  'nationality',
  'no_of_employees',
  'no_of_employees_residing_area',
  'no_of_female_employees',
  'no_of_male_employees',
  'no_of_motorcycle',
  'no_of_truck',
  'no_of_van',
  'no_of_vehicles',
  'main_office_barangay_code',
  'main_office_barangay_name',
  'main_office_display_address',
  'main_office_municipality_code',
  'main_office_municipality_name',
  'main_office_province_code',
  'main_office_province_name',
  'main_office_region_code',
  'main_office_region_name',
  'main_office_street',
  'main_office_zip_code',
  'or_date',
  'or_date_day',
  'or_date_month',
  'or_date_year',
  'or_days_of_week',
  'or_no',
  'owners_display_name',
  'owners_gender',
  'payment_channel',
  'pin_no',
  'pinned_geolocation',
  'pre_registration_date',
  'province_code',
  'province_name',
  'qr_url',
  'region_code',
  'region_name',
  'refno',
  'retired_at',
  'sec_no',
  'signatory_1_designation',
  'signatory_1_name',
  'signatory_1_signature',
  'signatory_2_designation',
  'signatory_2_name',
  'signatory_2_signature',
  'signatory_3_designation',
  'signatory_3_name',
  'signatory_3_signature',
  'street',
  'tax_credit',
  'tax_credit_human',
  'tax_incentives_attachment_url',
  'tdn_no',
  'telephone_no',
  'tin_no',
  'total_business_activities_gross_amount',
  'trade_name',
  'transaction_type',
  'txnid',
  'validity_date',
  'veterinary_fee_id',
  'veterinary_fee_name',
  'with_tax_incentives',
  'zip_code',

  'account_address',
  'taxpayer_address',
  'printed_date_day_ordinal',
  'requestor_display_name',
  'payee_display_name',
  'total',

  'total_business_activities_capital_amount',
  'check_payment_bank_name',

  'barangay_clearance_signatory_name',
  'barangay_clearance_signatory_designation',
  'barangay_clearance_signatory_signature',

  'barangay_logo',
  'brgy_fees_total',
  'brgy_fees',
  'brgy_clearance_no',

  'check_payment_date',
  'check_payment_number',

  'business_tax',

  'payment_method',

  'retired_business_line',
  'retired_business_lines', 
  'retirement_reason',
  'actual_closure_date',
  'latest_or_date',
  'or_date_latest_day',
  'or_date_latest_month',
  'or_date_latest_year',
  'or_days_latest_of_week',
  'earliest_or_date',
  'or_date_earliest_day',
  'or_date_earliest_month',
  'or_date_earliest_year',
  'or_days_earliest_of_week',
  'registration_number',
];
